// extracted by mini-css-extract-plugin
export var oaForm = "bQ_hy";
export var oaForm100 = "bQ_hB";
export var oaForm50 = "bQ_hz";
export var oaFormError = "bQ_hC";
export var oaFormHighlight = "bQ_hD";